import * as React from 'react';
import classNames from 'classnames';
export default function Pin(props) {
  var children = props.children,
      active = props.active;

  function onClickHandle(e) {
    e.preventDefault();
    e.stopPropagation();
    props.onClick();
  }

  return React.createElement("span", {
    className: classNames("".concat(props.prefixCls, "-body-options-item"), {
      'active': active
    }),
    onClick: function onClick(e) {
      return onClickHandle(e);
    }
  }, children);
}
Pin.defaultProps = {
  prefixCls: 'mkui-table-filter'
};
//# sourceMappingURL=Pin.js.map
